// @ts-check
import React, { forwardRef } from "react"
import { Dropdown as PrimeDropdown } from "primereact/dropdown"
import ProgressSpinner from "./misc/ProgressSpinner.atom"
import { clsx } from "../../utils/strings.utils"

/** @type {import("./Dropdown.atom.types.d.ts").DropdownAtom} */
const Dropdown = forwardRef((props, ref) => {
  const optionGroupLabel = props.optionGroupLabel
  const loading = props.loading !== undefined ? props.loading : false

  return (
    <PrimeDropdown
      emptyMessage={
        props.emptyMessage || "Misión fallida... no encontramos nada"
      }
      ref={ref}
      {...props}
      // @ts-ignore --- Dropdown types are not correct
      // it says it's string only, but a function also works correctly
      optionGroupLabel={optionGroupLabel}
      emptyFilterMessage={
        loading ?
          <ProgressSpinner className="loading-spinner" />
        : props.emptyFilterMessage
      }
      panelClassName={clsx(props.panelClassName, loading && "is-loading")}
      options={loading ? [1] : props.options}
      value={loading ? Infinity : props.value}
      itemTemplate={
        loading ?
          <ProgressSpinner className="loading-spinner" />
        : props.itemTemplate
      }
    />
  )
})

export default Dropdown
